import React, { useMemo } from 'react';

import LoadingSpinner from '../../components/loading/nestedSpinner';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import { filterLogs, groupLogsByDay } from './helpers';

import { ActivtyLog, AuditTrailFilterValue } from 'models/activty-log.model';

import AuditTrailView from './AuditTrailView';

type AuditTrailViewWrapperProps = {
    data: ActivtyLog[];
    isLoading: boolean;
    filters: AuditTrailFilterValue;
    showTarget?: boolean;
    getSummary?: (log: ActivtyLog, userLabel: string) => string;
};
const AuditTrailViewWrapper: React.FC<AuditTrailViewWrapperProps> = ({
    data,
    isLoading,
    filters,
    showTarget,
    getSummary,
}) => {
    const { sortedDates, groupedLogs } = useMemo(
        () => groupLogsByDay(filterLogs(data ?? [], filters)),
        [data, filters],
    );
    if (isLoading) return <LoadingSpinner />;
    if (sortedDates.length === 0) return <Empty>No changes yet.</Empty>;
    return (
        <AuditTrailView
            sortedDates={sortedDates}
            groupedLogs={groupedLogs}
            showTarget={showTarget}
            getSummary={getSummary}
        />
    );
};
const Empty = styled.div({
    fontSize: aampeTheme.size.font.textMedium,
    color: aampeTheme.colors.textAccessibleWG01,
});

export default AuditTrailViewWrapper;
